import { computed, inject, Provider } from '@angular/core';
import { EntityBoardData, ENTITY_BOARD_DATA } from '../context/entity.board.data';
import { EntityBoardStore } from '../state/entity.board.store';

/** Provides EntityBoardData backed by the component-scoped EntityBoardStore. */
export function provideEntityBoardData(): Provider {

  return {
    provide: ENTITY_BOARD_DATA,
    useFactory: (): EntityBoardData => {
      const store = inject(EntityBoardStore);
      const $headerResponse = computed(() => store.$headerQuery()?.data);
      const $itemsResponse = computed(() => store.$itemsQuery()?.data);
      const $items = computed(() => store.$items() as readonly unknown[]);
      const $request = computed(() => store.$itemsRequest());
      const $fetching = computed(() => !!store.$headerQuery()?.isFetching || !!store.$itemsQuery()?.isFetching);
      const $error = computed(() => store.$headerQuery()?.error ?? store.$itemsQuery()?.error ?? null);

      return {
        $headerResponse,
        $itemsResponse,
        $items,
        $request,
        $loading: store.$loading,
        $fetching,
        $error,
        refresh: () => store.refresh(),
      };
    },
  };
}
